export const playbooks = [
  {
    id: 'team-health-checks',
    title: 'Team Health Checks',
    description: 'A comprehensive guide to running effective team health checks',
    sections: [
      { 
        id: 'key-info',
        title: 'Key Info',
        description: 'Introduction and essential information about team health checks'
      },
      { 
        id: 'how-to-execute',
        title: 'How To Execute',
        description: 'Step-by-step guide to implementing team health checks'
      },
      { 
        id: 'stage-1',
        title: 'Stage 1: Crowd-source Indicators',
        description: 'First stage of the team health check process'
      },
      { 
        id: 'stage-2',
        title: 'Stage 2: Support Facilitation',
        description: 'Second stage of the team health check process'
      },
      { 
        id: 'stage-3',
        title: 'Stage 3: Collect Insights',
        description: 'Third stage of the team health check process'
      },
      { 
        id: 'stage-4',
        title: 'Stage 4: Create Accountability',
        description: 'Fourth stage of the team health check process'
      },
      { 
        id: 'useful-resources',
        title: 'Useful Resources',
        description: 'Templates, tools, and additional resources'
      },
      { 
        id: 'final-thoughts',
        title: 'Final Thoughts',
        description: 'Concluding remarks and recommendations'
      }
    ]
  },
  {
    id: 'working-through-conflict',
    title: 'Working Through Conflict',
    description: '3 Scenario Based Toolkits for navigating conflict in your organization',
    sections: [
      {
        id: 'key-info',
        title: 'Key Info',
        description: 'Introduction and essential information about working through conflict'
      },
      {
        id: 'how-to-execute',
        title: 'How To Execute',
        description: 'Step-by-step guide to implementing conflict resolution'
      },
      {
        id: 'stage-1',
        title: 'Scenario 1: Personal conflict',
        description: 'Handling direct conflict between you and someone else'
      },
      {
        id: 'stage-2',
        title: 'Scenario 2: Inter-team friction',
        description: 'Resolving conflicts between teams or functions not working well together'
      },
      {
        id: 'stage-3',
        title: 'Scenario 3: Dysfunctional leadership',
        description: 'Addressing leadership teams failing to work through conflict'
      },
      {
        id: 'useful-resources',
        title: 'Useful Resources',
        description: 'Articles, tools, and frameworks for conflict resolution'
      },
      {
        id: 'final-thoughts',
        title: 'Final Thoughts',
        description: 'Concluding thoughts and about the creators'
      }
    ]
  },
  {
    id: 'setting-boundaries',
    title: 'Setting Boundaries',
    description: 'Learn how to establish and maintain healthy boundaries in your organization',
    sections: [
      {
        id: 'key-info',
        title: 'Key Info',
        description: 'Introduction and essential information about setting boundaries'
      },
      {
        id: 'how-to-execute',
        title: 'How To Execute',
        description: 'Step-by-step guide to implementing healthy boundaries'
      },
      {
        id: 'stage-1',
        title: 'Stage 1: It starts with you',
        description: 'Clarify the scope of your own role and ensure alignment with leadership.'
      },
      {
        id: 'stage-2',
        title: 'Stage 2: Align as a team + make it open',
        description: 'Share with your team, align, and publish your team charter and roadmap.'
      },
      {
        id: 'stage-3',
        title: 'Stage 3: Analyse and course-correct',
        description: 'Check in on your team\'s WILO and make adjustments/support where needed.'
      },
      {
        id: 'useful-resources',
        title: 'Useful Resources',
        description: 'Templates, tools, and additional resources for setting boundaries'
      },
      {
        id: 'final-thoughts',
        title: 'Final Thoughts',
        description: 'Concluding remarks and recommendations for maintaining boundaries'
      }
    ]
  },
  {
    id: 'manager-community',
    title: 'Building A People Manager Community From Scratch',
    description: 'A step-by-step guide to establishing a thriving People Manager Community of Practice (PCoP) within your startup',
    sections: [
      { 
        id: 'key-info',
        title: 'Key Info',
        description: 'Introduction and essential information about building a manager community'
      },
      { 
        id: 'how-to-execute',
        title: 'How To Execute',
        description: 'Step-by-step guide to implementing a manager community'
      },
      { 
        id: 'stage-1',
        title: 'Stage 1: Recognising the need',
        description: 'First stage of the manager community process'
      },
      { 
        id: 'stage-2',
        title: 'Stage 2: Mobilising',
        description: 'Second stage of the manager community process'
      },
      { 
        id: 'stage-3',
        title: 'Stage 3: Establishment',
        description: 'Third stage of the manager community process'
      },
      { 
        id: 'stage-4',
        title: 'Stage 4: Sustaining',
        description: 'Fourth stage of the manager community process'
      },
      { 
        id: 'useful-resources',
        title: 'Useful Resources',
        description: 'Templates, tools, and additional resources'
      },
      { 
        id: 'final-thoughts',
        title: 'Final Thoughts',
        description: 'Concluding remarks and recommendations'
      }
    ]
  },
  {
    id: 'we-fucked-up',
    title: 'We F*cked Up. Now What?',
    description: 'A step-by-step guide to handling the aftermath of a f*ck up and rebuilding trust',
    sections: [
      { 
        id: 'key-info',
        title: 'Key Info',
        description: 'Introduction and essential information about handling mistakes'
      },
      { 
        id: 'how-to-execute',
        title: 'How To Execute',
        description: 'Step-by-step guide to implementing the recovery process'
      },
      { 
        id: 'stage-1',
        title: 'Stage 1: Own It & Address It',
        description: 'First stage of acknowledging and addressing the issue'
      },
      { 
        id: 'stage-2',
        title: 'Stage 2: Fix The Thing',
        description: 'Second stage of implementing solutions and maintaining communication'
      },
      { 
        id: 'stage-3',
        title: 'Stage 3: Learn From It',
        description: 'Final stage of extracting learnings and making long-term improvements'
      },
      { 
        id: 'useful-resources',
        title: 'Useful Resources',
        description: 'Templates, tools, and additional resources'
      },
      { 
        id: 'final-thoughts',
        title: 'Final Thoughts',
        description: 'Concluding remarks and recommendations'
      }
    ]
  },
  {
    id: 'feedback-culture',
    title: 'Feedback Culture',
    description: 'A comprehensive guide to building and maintaining a healthy feedback culture in your organization',
    sections: [
      { 
        id: 'key-info',
        title: 'Key Info',
        description: 'Introduction and essential information about feedback culture'
      },
      { 
        id: 'how-to-execute',
        title: 'How To Execute',
        description: 'Step-by-step guide to implementing a feedback culture'
      },
      { 
        id: 'stage-1',
        title: 'Stage 1: Baselining Feedback',
        description: 'First stage of establishing a feedback culture'
      },
      { 
        id: 'stage-2',
        title: 'Stage 2: Recognising Each Other\'s Needs',
        description: 'Second stage of implementing feedback preferences'
      },
      { 
        id: 'stage-3',
        title: 'Stage 3: Embedding Empathy',
        description: 'Final stage of embedding feedback into your culture'
      },
      { 
        id: 'useful-resources',
        title: 'Useful Resources',
        description: 'Templates, tools, and additional resources'
      },
      { 
        id: 'final-thoughts',
        title: 'Final Thoughts',
        description: 'Concluding remarks and recommendations'
      }
    ]
  },
  {
    id: 'transparency-charter',
    title: 'Buidling A Transparency Charter',
    description: 'A step-by-step guide to building a transparency charter within your startup',
    sections: [
      { 
        id: 'key-info',
        title: 'Key Info',
        description: 'Introduction and essential information about creating a transparency charter'
      },
      { 
        id: 'how-to-execute',
        title: 'How To Execute',
        description: 'Step-by-step guide to implementing a transparency charter'
      },
      { 
        id: 'stage-1',
        title: 'Stage 1: Review Feedback & Data',
        description: 'First stage of identifying where lack of clarity & communication is causing negative sentiment'
      },
      { 
        id: 'stage-2',
        title: 'Stage 2: Transparency Charter',
        description: 'Second stage of building your transparency charter together'
      },
      { 
        id: 'stage-3',
        title: 'Stage 3: Engage, Embed & Reinforce',
        description: 'Final stage of sharing, embedding and reviewing your transparency charter'
      },
      { 
        id: 'useful-resources',
        title: 'Useful Resources',
        description: 'Templates, tools, and additional resources'
      },
      { 
        id: 'final-thoughts',
        title: 'Final Thoughts',
        description: 'Concluding remarks and recommendations'
      }
    ]
  },
  {
    id: 'culture-offsite',
    title: 'Culture Offsite: Culture Co-Creation',
    description: 'A step-by-step guide to running a culture co-creation offsite for effective team alignment',
    sections: [
      { 
        id: 'key-info',
        title: 'Key Info',
        description: 'Introduction and essential information about culture co-creation offsites'
      },
      { 
        id: 'how-to-execute',
        title: 'How To Execute',
        description: 'Step-by-step guide to implementing culture co-creation offsites'
      },
      { 
        id: 'stage-1',
        title: 'Stage 1: Setup & Preparation',
        description: 'First stage of the culture co-creation process'
      },
      { 
        id: 'stage-2',
        title: 'Stage 2: How to Facilitate',
        description: 'Second stage of the culture co-creation process'
      },
      { 
        id: 'stage-3',
        title: 'Stage 3: Publish & Implement',
        description: 'Final stage of the culture co-creation process'
      },
      { 
        id: 'useful-resources',
        title: 'Useful Resources',
        description: 'Templates, tools, and additional resources'
      },
      { 
        id: 'final-thoughts',
        title: 'Final Thoughts',
        description: 'Concluding remarks and recommendations'
      }
    ]
  },
  {
    id: 'resetting-behaviours',
    title: 'How To Reset Misaligned Behaviour',
    description: 'A step-by-step guide to resetting behaviours and addressing anti-values in your organization',
    sections: [
      { 
        id: 'key-info',
        title: 'Key Info',
        description: 'Introduction and essential information about resetting behaviours'
      },
      { 
        id: 'how-to-execute',
        title: 'How To Execute',
        description: 'Step-by-step guide to implementing behaviour reset'
      },
      { 
        id: 'stage-1',
        title: 'Stage 1: Address the elephant in the room',
        description: 'First stage of gathering examples and publicly addressing the problem'
      },
      { 
        id: 'stage-2',
        title: 'Stage 2: Dig deeper, what\'s the source of the anti-behaviours?',
        description: 'Second stage of understanding root causes and planning interventions'
      },
      { 
        id: 'stage-3',
        title: 'Stage 3: Reset the behaviours',
        description: 'Final stage of implementing changes and ensuring they stick'
      },
      { 
        id: 'useful-resources',
        title: 'Useful Resources',
        description: 'Articles, tools, and frameworks for behaviour reset'
      },
      { 
        id: 'final-thoughts',
        title: 'Final Thoughts',
        description: 'Concluding remarks and recommendations'
      }
    ]
  },
  {
    id: 'storytelling-with-data',
    title: 'Storytelling with Data',
    description: 'A comprehensive guide to using data and storytelling to get heard and influence effectively',
    sections: [
      { 
        id: 'key-info',
        title: 'Key Info',
        description: 'Introduction and essential information about data storytelling'
      },
      { 
        id: 'how-to-execute',
        title: 'How To Execute',
        description: 'Step-by-step guide to implementing data storytelling'
      },
      { 
        id: 'stage-1',
        title: 'Stage 1: Link to Business Outcome + Analyse Data',
        description: 'First stage of the data storytelling process'
      },
      { 
        id: 'stage-2',
        title: 'Stage 2: Tell Your Story In Their Language',
        description: 'Second stage of the data storytelling process'
      },
      { 
        id: 'useful-resources',
        title: 'Useful Resources',
        description: 'Templates, tools, and additional resources'
      },
      { 
        id: 'final-thoughts',
        title: 'Final Thoughts',
        description: 'Concluding remarks and recommendations'
      }
    ]
  },
  {
    id: 'employer-brand-unfiltered',
    title: 'Unfiltered: The Startup Employer Brand Playbook',
    description: 'A step-by-step guide to building an authentic employer brand that attracts the right talent',
    sections: [
      { 
        id: 'key-info',
        title: 'Key Info',
        description: 'Introduction and essential information about building an authentic employer brand'
      },
      { 
        id: 'how-to-execute',
        title: 'How To Execute',
        description: 'Step-by-step guide to implementing your employer brand strategy'
      },
      { 
        id: 'stage-1',
        title: 'Stage 1: Discover Your True EVP',
        description: 'First stage of uncovering your authentic Employer Value Proposition'
      },
      { 
        id: 'stage-2',
        title: 'Stage 2: Embed & Activate Your EVP',
        description: 'Second stage of bringing your EVP to life internally and externally'
      },
      { 
        id: 'stage-3',
        title: 'Stage 3: Measure & Improve',
        description: 'Final stage of tracking impact and continuously improving your employer brand'
      },
      { 
        id: 'useful-resources',
        title: 'Useful Resources',
        description: 'Templates, tools, and additional resources for building your employer brand'
      },
      { 
        id: 'final-thoughts',
        title: 'Final Thoughts',
        description: 'Concluding remarks and recommendations for maintaining an authentic employer brand'
      }
    ]
  },
  {
    id: 'leverage-ai-for-you-and-your-org',
    title: 'How To Leverage AI For Your Team, Yourself And Your Org',
    description: 'A simple but powerful framework for spotting AI use cases, building your first GPT agents, and scaling AI confidence across your organization',
    sections: [
      { 
        id: 'key-info',
        title: 'Key Info',
        description: 'Introduction and essential information about leveraging AI across your organization'
      },
      { 
        id: 'how-to-execute',
        title: 'How To Execute',
        description: 'Step-by-step guide to implementing AI adoption across your organization'
      },
      { 
        id: 'stage-1',
        title: 'Stage 1: Identify & Prioritise AI Opportunities',
        description: 'First stage of finding and evaluating AI use cases in your organization'
      },
      { 
        id: 'stage-2',
        title: 'Stage 2: Building Your First AI Products',
        description: 'Second stage of creating custom GPT agents and AI tools'
      },
      { 
        id: 'stage-3',
        title: 'Stage 3: Operationalising Further',
        description: 'Final stage of scaling AI adoption and embedding it into your culture'
      },
      { 
        id: 'useful-resources',
        title: 'Useful Resources',
        description: 'Tools, templates, policies, and additional resources for AI implementation'
      },
      { 
        id: 'final-thoughts',
        title: 'Final Thoughts',
        description: 'Concluding remarks and recommendations for sustainable AI adoption'
      }
    ]
  },
  {
    id: 'how-to-build-launch-embed-performance',
    title: 'How to Build, Launch & Embed Your Org\'s First Performance Framework',
    description: 'A comprehensive guide to building performance frameworks that work',
    sections: [
      { 
        id: 'key-info',
        title: 'Key Info',
        description: 'Introduction and essential information about building performance frameworks'
      },
      { 
        id: 'how-to-execute',
        title: 'How To Execute',
        description: 'Step-by-step guide to implementing performance frameworks'
      },
      { 
        id: 'stage-1',
        title: 'Stage 1: Align on Purpose of Performance',
        description: 'Why do we need this? Getting clear on your performance philosophy'
      },
      { 
        id: 'stage-2',
        title: 'Stage 2: Assess Your Building Blocks',
        description: 'Evaluate the foundations needed for effective performance practices'
      },
      { 
        id: 'stage-3',
        title: 'Stage 3: Agree & Align on How We\'ll Use Performance',
        description: 'Define how performance will influence growth, development, and reward'
      },
      { 
        id: 'stage-4',
        title: 'Stage 4: Design your Performance Framework',
        description: 'Build your framework structure and assessment approach'
      },
      { 
        id: 'stage-5',
        title: 'Stage 5: Launch it Well',
        description: 'Execute a successful rollout with manager buy-in and clear communication'
      },
      { 
        id: 'stage-6',
        title: 'Stage 6: Embed it, and Manage it like a Product',
        description: 'Make performance practices sticky and continuously improve the framework'
      },
      { 
        id: 'useful-resources',
        title: 'Useful Resources',
        description: 'Templates, tools, and additional resources for performance framework implementation'
      },
      { 
        id: 'final-thoughts',
        title: 'Final Thoughts',
        description: 'Concluding remarks and recommendations for sustainable performance practices'
      }
    ]
  }
];

// Helper function to move 'Useful Resources' to the last position in each playbook
playbooks.forEach(playbook => {
  const sections = playbook.sections;
  const usefulIdx = sections.findIndex(s => s.title && s.title.toLowerCase().includes('useful resources'));
  if (usefulIdx !== -1 && usefulIdx !== sections.length - 1) {
    const [useful] = sections.splice(usefulIdx, 1);
    sections.push(useful);
  }
});

// Helper function to get playbook by ID
export const getPlaybookById = (id) => {
  return playbooks.find(playbook => playbook.id === id);
};

// Helper function to get section by playbook ID and section ID
export const getSectionById = (playbookId, sectionId) => {
  const playbook = getPlaybookById(playbookId);
  if (!playbook) return null;
  return playbook.sections.find(section => section.id === sectionId);
};

// Helper function to get next/previous sections
export const getNavigationLinks = (playbookId, currentSectionId) => {
  const playbook = getPlaybookById(playbookId);
  if (!playbook) return { prev: null, next: null };

  const currentIndex = playbook.sections.findIndex(section => section.id === currentSectionId);
  if (currentIndex === -1) return { prev: null, next: null };

  return {
    prev: currentIndex > 0 ? playbook.sections[currentIndex - 1] : null,
    next: currentIndex < playbook.sections.length - 1 ? playbook.sections[currentIndex + 1] : null
  };
}; 